export interface NdjsonChunk {
  a?: string | null;
  c?: string[] | null;
  s?: number[] | null;
  e?: number[] | null;
}

// Returns false if the stream read failed (caller decides whether to surface the error).
export async function readNdjsonStream(
  body: ReadableStream<Uint8Array>,
  onChunk: (chunk: NdjsonChunk) => void,
): Promise<boolean> {
  const reader = body.getReader();
  const dec = new TextDecoder();
  let buf = '';
  try {
    while (true) {
      const { done, value } = await reader.read();
      if (done) break;
      buf += dec.decode(value, { stream: true });
      const lines = buf.split('\n');
      buf = lines.pop() ?? '';
      for (const line of lines) {
        if (!line.trim()) continue;
        onChunk(JSON.parse(line) as NdjsonChunk);
      }
    }
    // Flush decoder and process any final line not terminated by '\n'
    buf += dec.decode();
    if (buf.trim()) onChunk(JSON.parse(buf) as NdjsonChunk);
    return true;
  } catch {
    return false;
  }
}
